import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { observer, useAsObservableSource } from 'mobx-react-lite';
import {
    FolderPlusIconWrapper,
    TrashIconWrapper,
    ImageUploadWrapper,
    ButtonsWrapper,
    InputWrapper,
    FileInput,
    RemoveButtonWrapper,
    ImageWrapper,
    Image,
    ImagePlaceholder,
    OptimalizeButton,
    SizeInfo,
    FileInputLabel,
} from './ImageUpload.style';
import { GameImageUploaderState } from 'src/domains/casino/state/AppCasino/game-image-uploader/GameImageUploader.state';
import { GameType } from 'src/domains/casino/models/models';

export type UploadImageDimentionsType = 'horizontal' | 'vertical' | 'square';

interface ImageUploadPropsType {
    game: GameType;
    uploaderState: GameImageUploaderState;
    wrapperDimensions: UploadImageDimentionsType;
    dataTest?: string;
}

export const ImageUpload = observer((propsIn: ImageUploadPropsType) => {
    const props = useAsObservableSource(propsIn);
    const { game, wrapperDimensions, dataTest } = props;
    const { imagePreview, imageSize, handleRemoveImage, handleUploadImage, handleImageOptimise } = props.uploaderState;
    const outImage = imagePreview === '' ? props.game.image : imagePreview.toString();
    const isTooBig = imageSize !== null && parseInt(imageSize.size, 10) > 2000 ? true : false;

    return (
        <ImageUploadWrapper>
            <div>
                <ImageWrapper dimensions={wrapperDimensions}>
                    {/* eslint-disable-next-line no-negated-condition */}
                    {imagePreview !== '' ? (
                        <Image
                            alt={game.name}
                            src={outImage}
                        />
                    ) : (
                        <ImagePlaceholder dimensions={wrapperDimensions}>Upload image</ImagePlaceholder>
                    )}
                </ImageWrapper>
                {imagePreview !== '' && imageSize !== null ? (
                    <SizeInfo isTooBig={isTooBig}>
                        Image size: {imageSize.width} x {imageSize.height} : {imageSize.size} KB
                    </SizeInfo>
                ) : null}
            </div>
            <ButtonsWrapper>
                <InputWrapper>
                    <FolderPlusIconWrapper />
                    <FileInputLabel>
                        Upload New Image
                        <FileInput
                            type='file'
                            onChange={handleUploadImage}
                            accept='image/jpeg, image/png'
                            data-test={dataTest}
                        />
                    </FileInputLabel>
                </InputWrapper>
                <InputWrapper>
                    <OptimalizeButton onClick={handleImageOptimise}>Optimise</OptimalizeButton>
                </InputWrapper>
                <RemoveButtonWrapper
                    icon={<TrashIconWrapper />}
                    onClick={handleRemoveImage}
                >
                    Remove
                </RemoveButtonWrapper>
            </ButtonsWrapper>
        </ImageUploadWrapper>
    );
});
